export const COLORS = {
  BLACK: 'black',
  MUTED: '#202020',
  DARKGRAY: '#595959',
  GRAY: '#999999',
  LIGHTGRAY: '#bbbbbb',
  LIGHT: '#eeeeee',
  WHITE: 'white',

  RED: '#f85a3e',
  TEAL: '#63d4dd',
  PURPLE: '#a177ee',
} as const;
